import { BASE_URL } from "../config";

export async function getOrderHistory() {
    const accessToken = localStorage.getItem('accessToken');
    try {
        const response = await fetch(BASE_URL + '/user/orderHistory/get', {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });

        const responseBody = await response.json();
        console.log("Response");
        console.log(responseBody);
        return responseBody;
    } catch (error) {
        console.error(error);
    }
}